<template>
  <div class="custom-wrapper z-nopadd" :class="{active: visible}">
    <div class="position: relative;">
      <!-- .custom-company-exhibition === cce -->
      <div class="cce">
        <!-- 设置内容 -->
        <div class="ccep-content">
          <!-- <div style="word-break: break-all; white-space: pre-wrap;">{{Modal}}</div> -->
          <!-- <iSwitch size="large" v-model="Modal.isOpen" @on-change="changeExChoice" >
              <span slot="open">开启</span>
              <span slot="close">关闭</span>
          </iSwitch>-->
          <iSwitch size="large" v-model="true1" disabled>
            <span slot="open">开启</span>
            <span slot="close">关闭</span>
          </iSwitch>
          <!-- <span class="cce-info">点击{{ Modal.isOpen ? '关闭' : '开启'}}展会</span>
            <div style="padding-top: 20px;">
              <Input
                search
                enter-button="选择展会"
                placeholder="请选择展会"
                @click.native="showExModal()"
                v-model="exName"
                :disabled="!Modal.isOpen"
              />
            </div>
            <div class="ccep-info">
              <div class="ccep-info__item">
                <div>展位类别：</div>
                <template v-if="Modal.Categories && Modal.Categories.length">
                  <div
                    class="ccep-info__item-txt"
                    :title="Modal.Categories.join('、')"
                  >{{Modal.Categories.join('、')}}</div>
                </template>
                <div v-else class="ccep-info__item-txt">未设置</div>
              </div>
              <div class="ccep-info__item">
                <div>展位号：</div>
                <div class="ccep-info__item-txt" v-if="Modal && Modal.BoothInfo">
                  <template
                    v-for="(c, index) in Modal.BoothInfo"
                  >{{(index + 1 === Modal.BoothInfo.length) ? `${c.Hall}-${c.Code}` :`${c.Hall}-${c.Code}、`}}</template>
                </div>
                <div v-else class="ccep-info__item-txt">未设置</div>
              </div>
              <div class="ccep-info__item">
                <div
                  class="ccep-info__item-txt"
                  v-if="Modal && Modal.BoothArea"
                >展位面积：{{Modal.BoothArea || ''}} m²</div>
                <div v-else class="ccep-info__item-txt">展位面积：0 m²</div>
              </div>
          </div>-->
        </div>
      </div>
    </div>
    <iModal v-if="false" v-model="modal3" :mask-closable="false" :footer-hide="true" width="800">
      <div class="register-form">
        <div class="rf-title">关联展会</div>
        <Form ref="formInline" label-position="right" :label-width="150" @submit.native.prevent>
          <FormItem label="选择展会：">
            <Input type="text" v-model="exName" @click.native="add = true" readonly>
              <i class="icon iconfont icon-daohang1" slot="suffix"></i>
            </Input>
          </FormItem>
        </Form>
      </div>
      <div class="register-form">
        <div class="rf-title">参展信息</div>
        <Form
          ref="formInline"
          :model="formInline"
          :rules="ruleInline"
          label-position="right"
          :label-width="150"
          @submit.native.prevent
        >
          <FormItem label="产品类别：" prop="type">
            <Select
              v-model="formInline.type"
              filterable
              placeholder="产品类别"
              multiple
              @on-change="selectChange"
            >
              <Option v-for="item in exTypeArr" :value="item.name" :key="item.name">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="展馆信息：" prop="type">
            <Select v-model="formInline.hall" filterable placeholder="展馆信息">
              <Option
                v-for="item in exHallArr"
                :value="item.name"
                :key="item.name"
              >{{ item.name }} - {{item.value}}</Option>
            </Select>
          </FormItem>
          <FormItem label="展位号：" prop="num">
            <Input type="text" v-model="formInline.num" placeholder="请输入展位号" />
          </FormItem>
        </Form>
      </div>
    </iModal>
    <!-- 选择展会 -->
    <exhibitionChoiceModal :show="modal3" @close="modal3=false" @change="sendSubmit" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import popper from "@components/vue-popper-new/VuePopperNew.vue";
import exhibitionChoiceModal from "./subpages/exhibition-choice-modal.vue";

export default {
  // 展会
  name: "custom-company-exhibition",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    Modal: {
      type: Object,
      default: function() {
        return {
          type: 8,
          isOpen: true,
          ExHall: "",
          BoothCode: "",
          BoothInfo: [],
          Categories: [],
          ExhibitionId: "",
          BoothArea: 0
        };
      }
    }
  },
  data() {
    return {
      true1: true,
      modal3: false,
      add: false,
      visible: false,
      exName: "",
      exhibition: null,
      choiceData: null,

      loading: false, // 是否可以获取验证码
      formInline: {
        // form双向绑定
        type: [],
        hall: null,
        num: "",
        area: 0
      },
      ruleInline: {
        num: [{ required: true, message: "展位号不能为空", trigger: "blur" }]
      },
      exTypeArr: [], // 展商类别
      exHallArr: [], // 展商类别
      categories: []
    };
  },
  watch: {
    exhibition(val, oldVal) {
      if (val) {
        if (oldVal && val.operatorId === oldVal.operatorId) return;
        this.init(val.id);
      }
    },
    activeIndex(val, oldVal) {
      // if (val !== this.index) this.visible = false;
    },
    visible(val, oldVal) {
      if (!val) {
        this.handleSubmit();
      }
    }
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      activeIndex: "customCompanyModule/getActiveIndex"
    })
  },
  created() {
    if (this.$route.query && this.$route.query.type !== "add") {
      this.getDefaultEx();
    } else {
      this.add = true;
    }
  },
  methods: {
    ...mapMutations({
      setExhibition: "loginModule/setExhibition",
      setActiveIndex: "customCompanyModule/setActiveIndex",
      setJoinEx: "companyModule/setJoinEx"
    }),
    ...mapActions({
      getHallByExhibition: "exhibitionModule/getHallByExhibition",
      getCategoryByExhibition: "exhibitionModule/getCategoryByExhibition",
      getJoinExhibitionInfoByCompId:
        "exhibitionModule/getJoinExhibitionInfoByCompId",
      getExhibitionById: "exhibitionModule/getExhibitionById",
      getJoinById: "exhibitionModule/getJoinById"
    }),
    async init(id) {
      let hallData = await this.getHallByExhibition(id);
      if (hallData && hallData.length) {
        this.exHallArr = hallData;
      } else {
        this.exHallArr = [];
      }
      let categoryData = await this.getCategoryByExhibition(id);
      if (categoryData && categoryData.length) {
        this.exTypeArr = categoryData;
      } else {
        this.exTypeArr = [];
      }
      if (
        (this.exHallArr && this.exHallArr.length) ||
        (this.exTypeArr && this.exTypeArr.length)
      ) {
        this.getInfo();
      } else {
        this.formInline.type = [];
        this.formInline.hall = null;
        this.formInline.num = "";
        this.formInline.area = "";
      }
    },
    setVisible() {
      this.visible = !this.visible;
      this.setActiveIndex(this.index);
    },
    setEx(item) {
      this.modal3 = false;
      if (item.Exhibition) {
        this.setExhibition(item.Exhibition);
        this.exName = item.Exhibition.name;
        this.exhibition = item.Exhibition;
        this.area = item.BoothArea;

        this.exHallArr = [];
        this.exTypeArr = [];
        this.formInline.type = [];
        this.formInline.hall = null;
        this.choiceData = item;
      }
    },
    setInitEx(item) {
      this.modal3 = false;
      if (item) {
        this.exhibition = item;
        this.exName = item.name;
      }
      this.init(item.id);
    },
    async getDefaultEx() {
      const query = this.$route.query;
      let ex = null;
      let res = await this.getJoinById(query.editId);
      if (res && res.exhibitionId) {
        this.setJoinEx(res);
        ex = await this.getExhibitionById(res.exhibitionId);
      }
      if (ex && ex.id) {
        this.setInitEx(ex);
      }
    },
    async getInfo() {
      const copyData = JSON.parse(JSON.stringify(this.Modal));
      copyData.ExhibitionId = this.exhibition.id;
      // 通过公司和展会id获取参展信息
      let data = await this.getJoinExhibitionInfoByCompId({
        compId: this.company.id,
        exhibitionId: this.exhibition.id
      });
      if (data) {
        data.categories = data.categories ? JSON.parse(data.categories) : [];
        data.compInfo = data.compInfo ? JSON.parse(data.compInfo) : null;
        data.exInfo = data.exInfo ? JSON.parse(data.exInfo) : null;
      }

      if (data && data.exHall) {
        this.formInline.hall = data.exHall;
        copyData.ExHall = data.exHall;
      }
      if (data && data.boothCode) {
        this.formInline.num = data.boothCode;
        copyData.BoothCode = data.boothCode;
      }
      if (data && data.boothArea) {
        this.formInline.area = data.boothArea;
        copyData.BoothArea = data.boothArea;
      }
      this.$emit("sendModal", copyData);
    },
    selectChange(e) {
      if (e && e.length > 3) {
        this.formInline.type = [e[0], e[1], e[2]];
      }
    },
    async handleSubmit() {
      if (!this.exhibition) return;
      let formData = this.Modal;
      if (this.choiceData && this.choiceData.BoothCode) {
        formData = {
          type: 8,
          isOpen: this.Modal.isOpen,
          ExHall: this.Modal.ExHall,
          BoothCode: this.choiceData.BoothCode,
          BoothInfo: this.choiceData.BoothInfo,
          Categories: this.choiceData.Categories,
          ExhibitionId: this.exhibition.id,
          BoothArea: this.choiceData.BoothArea
        };
      }
      this.$emit("sendModel", formData);
      this.modal3 = false;
      this.choiceData = null;
    },
    sendSubmit(data) {
      this.choiceData = data;
      if (data && data.Exhibition) {
        this.exhibition = data.Exhibition;
      }
      if (!this.exhibition) {
        return;
      }
      if (data) {
        this.exName = data.Exhibition.name;
        this.exhibition = data.Exhibition;
      }
      if (
        data &&
        data.Categories &&
        data.Categories.length &&
        this.exTypeArr &&
        this.exTypeArr.length
      ) {
        this.formInline.type = [];
        data.Categories.forEach(c => {
          this.formInline.type.push(c.Value);
        });
      }
      this.$emit("sendModal", {
        type: 8,
        isOpen: this.Modal.isOpen,
        ExHall: this.Modal.ExHall,
        BoothCode: this.choiceData.BoothCode,
        BoothInfo: this.choiceData.BoothInfo,
        Categories: this.choiceData.Categories,
        ExhibitionId: this.exhibition.id,
        BoothArea: this.choiceData.BoothArea
      });
      this.modal3 = false;
    },
    showExModal() {
      if (this.Modal.isOpen) {
        this.modal3 = true;
      }
    },
    changeExChoice(status) {
      if (!status) {
        this.exHallArr = [];
        this.exTypeArr = [];
        this.formInline.type = [];
        this.formInline.hall = null;
        this.formInline.num = "";
        this.exhibition = null;
        this.exName = "";
        const emptyData = {
          type: 8,
          isOpen: false,
          ExHall: "",
          BoothCode: "",
          BoothInfo: [],
          Categories: [],
          ExhibitionId: ""
        };
        this.$emit("sendModal", emptyData);
      }
    }
  },
  components: {
    popper,
    exhibitionChoiceModal
  }
};
</script> 
<style scoped lang="scss">
.register-form {
  font-size: 14px;
  width: 600px;
  margin: 0 auto;
  .rf {
    &-title {
      font-size: 20px;
      color: #333;
      padding: 60px 0 44px;
      text-align: center;
    }
  }
  .form-tip-info {
    color: #1890ff;
    cursor: pointer;
  }
}
.cce {
  width: 100%;
  &-info {
    display: inline-block;
    padding-left: 40px;
    font-size: 14px;
    color: #808080;
  }
  &-box {
    font-size: 0;
    background-color: #fff;
    cursor: pointer;
    div {
      word-break: break-all;
    }
  }
  .ccep {
    &-info {
      display: flex;
      &__item {
        width: 33.3333%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-top: 20px;
        display: flex;
        &:nth-child(2) {
          text-align: center;
        }
        &:nth-child(3) {
          text-align: right;
        }
        &-txt {
          font-size: 14px;
          color: #333;
          display: inline-block;
          flex: 1;
          width: calc(100% - 1px);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: left;
        }
      }
    }
    &-title {
      padding: 20px 30px;
      font-size: 14px;
      color: #333;
      border-bottom: solid 1px #ddd;
    }
    &-content {
      padding: 40px 50px;
      .addlink {
        border: dashed 1px #bfbfbf;
        text-align: center;
        color: #1890ff;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
.ct {
  &-components {
    .ctc {
      &-title {
        padding: 10px 20px;
        font-size: 14px;
        color: #333;
      }
      &-group {
        padding: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-item {
        width: 95px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #ebebeb;
        text-align: center;
        padding-top: 5px;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          color: #222;
        }
        &-txt {
          width: 100%;
          font-size: 12px;
          color: #222;
        }
      }
    }
  }
}
.custom-wrapper {
  &.z-nopadd {
    padding: 0 0 10px;
  }
  &:hover,
  &.active {
    .custom-item {
      border: 1px solid #1890ff;
    }
  }
}
</style>
